const CONTRACT_IN_PROGRESS_STATUSES = new Set([
  "pending",
  "initializing",
  "generating_document",
  "generating_code",
  "building_pdf",
]);

export const isContractInProgress = (status) =>
  CONTRACT_IN_PROGRESS_STATUSES.has(String(status || "").toLowerCase());
